import {Link, useSearchParams} from 'react-router-dom';
import React, {useEffect, useRef, useState} from 'react';
import {useProviderProfile} from "../../ProviderProfileProvider";
import {RpcState} from "../../util/RpcState";
import {useRpcSender} from "../../util/RpcSender";

import {useNavigateWithParams} from "../../util/NavUtils";
import {AcceptBusinessInviteRequest, AcceptBusinessInviteResponse} from "../../provider_api";
import {useAuth0} from "@auth0/auth0-react";
import {useKensuAuth} from "../../util/authwrapper/AuthWrapper";
import {LoadingDots} from "../../util/UI/LoadingDots";

/**
 * This actually redeems the invite. This should come directly from Auth0, because the join
 * page redirects to Auth0 and sets the redirect to this page.
 */
export const RedeemBusinessInvite = () => {


  const {user, isLoading} = useKensuAuth();

  const [searchParams] = useSearchParams();
  const inviteCode = searchParams.get('inviteCode');

  const rpcSender = useRpcSender();
  const {setProvider, business, setBusiness} = useProviderProfile();

  const navigate = useNavigateWithParams();

  // Prevent duplicate sends in react strict mode.
  const rpcSent = useRef(false);
  const [rpcState, setRpcState] = useState<RpcState>({state: 'pending'});

  // The effect for checking an invite code; this only happens if there is no authenticated user.
  useEffect(() => {

    if (!user) {
      return;
    }

    if (rpcSent.current) {
      console.log('not resending rpc')
      return;
    }

    // This invite only goes out if there's an invite code and it's been confirmed that
    // there is no authenticated user. This then checks whether the invite is valid.
    if (!inviteCode || business) {
      return;
    }

    rpcSent.current = true;
    let request = AcceptBusinessInviteRequest.encode(new AcceptBusinessInviteRequest({
      inviteCode: inviteCode,
      accepted: true,
    })).finish();

    rpcSender.send('action/accept_business_invite', request).then(r => {
      let response = AcceptBusinessInviteResponse.decode(r);
      console.log(response, JSON.stringify(response));
      if (response.okay) {
        // This changes the context value which forces a rerender
        setProvider(response.provider);
        setBusiness(response.business);

        // Clear out the search param and just go to the home page.
        navigate('/home');
      } else {
        setRpcState({state: 'error', message: 'Error redeeming your invite'})
      }
    }).catch(e => {
      setRpcState({state: 'error', message: 'Network error redeeming your invite'})
    });
  }, [user]);


  if (!isLoading) {
    return <div>Loading...<LoadingDots/></div>
  }
  
  // There should be a user because the user would have come from auth 0. 
  if (!user) {
    return <div className={'ErrorText'}>Error redeeming invite; login was not successful.&nbsp;
      Please contact support@onkensu.com if the issue continues.</div>
  }
  
  // Uh, they have a business already? Go to the home screen.
  if (business) {
    return <div>We already found a business associated with this login. Please
      <Link to={'/home'}>click here</Link> to visit your dashboard.</div>
  }

  if (rpcState.state == 'pending') {
    return <div>Redeeming your invite...</div>
  }

  if (rpcState.state == 'success') {
    return <div>You're in!</div>
  }

  return <div className={'ErrorText'}>
    Error redeeming invite code. Please contact us at support@onkensu.com.
  </div>
}
